import { gatewayInstance } from "../axiosInstance";
import { SERVICE_ENDPOINT } from "../const";

export const clusterNameDropdown = async () => {
  try {
    const response = await gatewayInstance.get(
      `${SERVICE_ENDPOINT.TRANSPORT}/stakeholderclustername`,
    );

    return response.data.map((item) => ({
      key: item.clnId,
      text: item.clnCluster,
      value: item.clnId,
    }));
  } catch (e) {
    console.error(e);
  }
};

export const getClusterName = async (id) => {
  try {
    const response = await gatewayInstance.get(
      `${SERVICE_ENDPOINT.TRANSPORT}/clustername/${id}`,
    );
    return response.data.clnCluster;
  } catch (e) {
    console.error(e);
  }
};

export const addCluster = async (data) => {
  try {
    const response = await gatewayInstance.post(
      `${SERVICE_ENDPOINT.TRANSPORT}/clustercreation`,
      data,
    );
  } catch (e) {
    console.error(e);
  }
};

export const updateCluster = async (data) => {
  try {
    const response = await gatewayInstance.put(
      `${SERVICE_ENDPOINT.TRANSPORT}/clustercreation`,
      data,
    );
  } catch (e) {
    console.error(e);
  }
};
export const searchCluster = async (data) => {
  try {
    console.log(data);
    const response = await gatewayInstance.post(
      `${SERVICE_ENDPOINT.TRANSPORT}/clustername/search`,
      data,
    );
    console.log(response);
    return response.data;
  } catch (e) {
    console.error(e);
  }
};
export const clusterById = async (id) => {
  try {
    const response = await gatewayInstance.get(
      `${SERVICE_ENDPOINT.TRANSPORT}/clustercreation/${id}`,
    );
    console.log(response);
    return response.data;
  } catch (e) {
    console.error(e);
  }
};
